var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-edit fa-lg icon-button",attrs:{"title":"Atualizar Filial"},on:{"click":function($event){$event.stopPropagation();return _vm.atualizarFilial()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }